import React from 'react';

import { useAuth } from '../../hooks/auth';

import LayoutDrSaude from './DrSaude';
import LayoutDrSaoPaulo from './DrSaoPaulo';

type ComponentProps = {
  CliCodigo?: number;
  assinatura?: {
    nome: string;
    especialidade: string;
    documento: string;
    conselho: string;
  };
  rodape?: boolean;
  duasVias?: boolean;
};

const LayoutImpressao: React.FC<ComponentProps> = ({
  CliCodigo,
  assinatura,
  rodape = true,
  duasVias,
  children,
}) => {
  const { clinica } = useAuth();

  const { CliDrSaude } = clinica;

  return CliDrSaude ? (
    <LayoutDrSaude
      CliCodigo={CliCodigo}
      assinatura={assinatura}
      rodape={rodape}
      duasVias={duasVias}
    >
      {children}
    </LayoutDrSaude>
  ) : (
    <LayoutDrSaoPaulo
      CliCodigo={CliCodigo}
      assinatura={assinatura}
      rodape={rodape}
      duasVias={duasVias}
    >
      {children}
    </LayoutDrSaoPaulo>
  );
};

export default LayoutImpressao;
